export default "__VITE_ASSET__CmflC2Kh__"